import { Callout } from '../../../../../components/Callout';
import { CustomFormattedMessage } from '../../../../../i18n/i18n';

type UnsubscribedVehiclesCalloutProps = {
  unsubscribedVehiclesCount: number;
  onClick: () => void;
  onClose: () => void;
};

export const UnsubscribedVehiclesCallout = ({
  unsubscribedVehiclesCount,
  onClose,
  onClick,
}: UnsubscribedVehiclesCalloutProps) => (
  <Callout
    data-testid="your-insights-unsubscribed-vehicles"
    type="secondary"
    title={
      <CustomFormattedMessage
        id={
          unsubscribedVehiclesCount !== 1
            ? 'overview.yourSimplePay.unsubscribedVehicles.title.plural'
            : 'overview.yourSimplePay.unsubscribedVehicles.title.singular'
        }
        values={{ count: unsubscribedVehiclesCount }}
      />
    }
    description={
      <CustomFormattedMessage id="overview.yourSimplePay.noServiceVehicles.description" />
    }
    onClick={onClick}
    onClose={onClose}
  />
);
